import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const bestDoctors = [
  {
    id: "vivek-vij",
    name: "Dr. Vivek Vij",
    specialty: "Liver Transplant",
    experience: "15 Yrs of experience",
    image: "/images/image copy 25.png",
    link: "/doctors/dr-vivek-vij/",
    description:
      "Expert in liver transplant surgeries with a high success rate.",
    qualifications: "MBBS, MS, DNB (Surgery), Fellowship in Liver Transplant",
    about:
      "Dr. Vivek Vij is one of India's leading liver transplant surgeons with extensive expertise in complex surgeries and patient care.",
    hospital: "Fortis Hospital, Noida",
    country: "India",
  },
  {
    id: "sandeep-vaishya",
    name: "Dr. Sandeep Vaishya",
    specialty: "Neurosurgery",
    experience: "24 Yrs of experience",
    image: "/images/image copy 26.png",
    link: "/doctors/dr-sandeep-vaishya/",
    description:
      "Top neurosurgeon known for brain tumor and spine surgery expertise.",
    qualifications: "MBBS, MS (General Surgery), MCh (Neurosurgery)",
    about:
      "Dr. Sandeep Vaishya has performed thousands of complex brain and spine procedures with outstanding outcomes.",
    hospital: "Fortis Memorial Research Institute, Gurgaon",
    country: "India",
  },
  {
    id: "dharma-choudhary",
    name: "Dr. Dharma Choudhary",
    specialty: "Hemato Oncology",
    experience: "20 Yrs of experience",
    image: "/images/image copy 28.png",
    link: "/doctors/dr-dharma-choudhary/",
    description:
      "Renowned specialist in bone marrow transplants and blood cancers.",
    qualifications: "MBBS, MD (Medicine), DM (Clinical Hematology)",
    about:
      "Dr. Choudhary is well-regarded for his work in leukemia, lymphoma, and stem cell transplants.",
    hospital: "BLK Super Specialty Hospital, Delhi",
    country: "India",
  },
  {
    id: "rana-patir",
    name: "Dr. Rana Patir",
    specialty: "Neurosurgery",
    experience: "32 Yrs of experience",
    image: "/images/image copy 27.png",
    link: "/doctors/dr-rana-patir/",
    description:
      "Senior neurosurgeon with vast experience in complex brain surgeries.",
    qualifications: "MBBS, MS (Surgery), MCh (Neurosurgery)",
    about:
      "Dr. Patir has been a pioneer in neurosurgical techniques and leads many successful procedures every year.",
    hospital: "Fortis Memorial Research Institute, Gurgaon",
    country: "India",
  },
  {
    id: "atul-peters",
    name: "Dr. Atul Peters",
    specialty: "Cardiac Surgeon",
    experience: "40 Yrs of experience",
    image: "/images/image copy 32.png",
    link: "/doctors/dr-naresh-trehan/",
    description:
      "Veteran cardiac surgeon with decades of experience in heart surgeries.",
    qualifications: "MBBS, MS (General Surgery), MCh (Cardiothoracic Surgery)",
    about:
      "Dr. Atul Peters has dedicated his life to advancing cardiovascular surgery in India.",
    hospital: "Max Super Specialty Hospital, Delhi",
    country: "India",
  },
  {
    id: "ips-oberoi",
    name: "Dr. IPS Oberoi",
    specialty: "Orthopaedic",
    experience: "28 Yrs of experience",
    image: "/images/image copy 30.png",
    link: "/doctors/dr-arvinder-soin/",
    description: "Renowned for knee, hip, and joint replacement surgeries.",
    qualifications: "MBBS, MS (Orthopedics), Fellowship in Joint Replacement",
    about:
      "Dr. Oberoi is one of the pioneers in computer-assisted orthopedic surgeries in India.",
    hospital: "Artemis Hospital, Gurgaon",
    country: "India",
  },
  {
    id: "hitesh-garg",
    name: "Dr. Hitesh Garg",
    specialty: "Orthopedic",
    experience: "15 Yrs of experience",
    image: "/images/image copy 29.png",
    link: "/doctors/dr-ashok-rajgopal/",
    description:
      "Spine and orthopedic surgeon with focus on deformity correction.",
    qualifications: "MBBS, MS (Ortho), Fellowship in Spine Surgery",
    about:
      "Dr. Garg has successfully treated thousands of patients with scoliosis, kyphosis, and spinal disorders.",
    hospital: "Artemis Hospital, Gurgaon",
    country: "India",
  },
  {
    id: "hemant-sharma",
    name: "Dr. Hemant Sharma",
    specialty: "Orthopedic",
    experience: "22 Yrs of experience",
    image: "/images/image copy 31.png",
    link: "/doctors/dr-Hemant-Sharma/",
    description:
      "Specialist in trauma, joint replacement, and orthopedic surgeries.",
    qualifications: "MBBS, MS (Ortho), Fellowship in Arthroplasty",
    about:
      "Dr. Hemant Sharma brings expertise in treating sports injuries, arthritis, and performing complex orthopedic procedures.",
    hospital: "FMRI, Gurgaon",
    country: "India",
  },
];

const StarDoctorsIndia = () => {
  const scrollRef = useRef(null);
  const scrollCardWidth = 270;
  const totalDoctors = bestDoctors.length;
  const autoScrollTimer = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const container = scrollRef.current;
    const startAutoScroll = () => {
      autoScrollTimer.current = setInterval(() => {
        if (!container || isUserScrolling) return;
        const scrollAmount = scrollCardWidth;
        const maxScrollLeft =
          scrollCardWidth * totalDoctors * 2 - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft - scrollAmount) {
          container.scrollLeft = 0;
        } else {
          container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
      }, 3000);
    };

    startAutoScroll();
    return () => clearInterval(autoScrollTimer.current);
  }, [isUserScrolling, totalDoctors]);

  const scroll = (direction) => {
    const container = scrollRef.current;
    const scrollAmount =
      direction === "left" ? -scrollCardWidth : scrollCardWidth;
    const maxScrollLeft =
      scrollCardWidth * totalDoctors * 2 - container.clientWidth;
    setIsUserScrolling(true);
    clearInterval(autoScrollTimer.current);

    if (
      direction === "right" &&
      container.scrollLeft >= maxScrollLeft - scrollCardWidth
    ) {
      container.scrollLeft = 0;
    } else if (direction === "left" && container.scrollLeft <= 0) {
      container.scrollLeft = maxScrollLeft;
    } else {
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }

    setTimeout(() => setIsUserScrolling(false), 10000);
  };

  // Mouse drag support
  useEffect(() => {
    const container = scrollRef.current;
    let isDown = false;
    let startX, scrollLeft;

    const handleDown = (e) => {
      isDown = true;
      container.classList.add("cursor-grabbing");
      startX = e.pageX - container.offsetLeft;
      scrollLeft = container.scrollLeft;
    };

    const handleUp = () => {
      isDown = false;
      container.classList.remove("cursor-grabbing");
    };

    const handleMove = (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - container.offsetLeft;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    };

    container.addEventListener("mousedown", handleDown);
    container.addEventListener("mouseup", handleUp);
    container.addEventListener("mouseleave", handleUp);
    container.addEventListener("mousemove", handleMove);

    return () => {
      container.removeEventListener("mousedown", handleDown);
      container.removeEventListener("mouseup", handleUp);
      container.removeEventListener("mouseleave", handleUp);
      container.removeEventListener("mousemove", handleMove);
    };
  }, []);

  const handleCardClick = (doctor) => {
    navigate(`/doctor-details/${doctor.id}`, { state: doctor });
  };

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h3 className="text-4xl font-bold">
            <span className="text-[#1976f2]">Star Doctors </span> of India
          </h3>
          <p className="text-gray-700 text-lg mt-2">
            The most renowned and globally acclaimed doctors
          </p>
        </div>

        <div className="relative">
          <div
            ref={scrollRef}
            className="flex overflow-x-auto gap-6 no-scrollbar px-1 cursor-grab"
            style={{ scrollBehavior: "smooth" }}
          >
            {[...bestDoctors, ...bestDoctors].map((doc, idx) => (
              <div
                key={idx}
                onClick={() => handleCardClick(doc)}
                className="flex-shrink-0 w-[250px] bg-white rounded-lg shadow hover:shadow-md transition p-4 text-center cursor-pointer"
              >
                <img
                  src={doc.image}
                  alt={doc.name}
                  className="rounded-lg mx-auto mb-4 h-40 w-full object-cover"
                />
                <h4 className="text-xl font-semibold mb-1 text-[#1976f2] hover:underline">
                  {doc.name}
                </h4>
                <h6 className="text-[#1976f2] font-medium mb-1">
                  {doc.specialty}
                </h6>
                <h5 className="text-gray-600">{doc.experience}</h5>
              </div>
            ))}
          </div>

          <div className="flex justify-center mt-6 gap-4">
            <button
              onClick={() => scroll("left")}
              className="bg-white border rounded-full p-2 shadow hover:bg-gray-100"
            >
              ◀️
            </button>
            <button
              onClick={() => scroll("right")}
              className="bg-white border rounded-full p-2 shadow hover:bg-gray-100"
            >
              ▶️
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StarDoctorsIndia;